import React from 'react';
import { Routes, Route } from 'react-router-dom';

import CustomFieldsRedirect from '../../components/body/settings/CustomFieldsRedirect';
import SettingsDefaultValuesContainer from '../../containers/settings/SettingsDefaultValuesContainer';
import SettingsScorecardContainer from '../../containers/settings/SettingsScorecardContainer';
import SettingsAutoCareVersions from '../../containers/settings/SettingsAutoCareVersions';
import SettingsXMLHeadersContainer from '../../containers/settings/SettingsXMLHeadersContainer';
import SettingsPriceSheetsContainer from '../../containers/settings/SettingsPriceSheetsContainer';
import SettingsBrandCustomDataContainer from '../../containers/settings/SettingsBrandCustomDataContainer';

const SettingsRoutes = () => (
  <Routes>
    <Route path="custom-fields" element={<CustomFieldsRedirect />} />
    <Route path="scorecards" element={<SettingsScorecardContainer />} />
    <Route path="default-values" element={<SettingsDefaultValuesContainer />} />
    <Route path="auto-care-table-version" element={<SettingsAutoCareVersions />} />
    <Route path="xml-headers" element={<SettingsXMLHeadersContainer />} />
    <Route path="price-sheets" element={<SettingsPriceSheetsContainer />} />
    <Route path="brand-custom-data" element={<SettingsBrandCustomDataContainer />} />
  </Routes>
);

export default SettingsRoutes;
